import { render, staticRenderFns } from "./setSignList.vue?vue&type=template&id=5cc4c63c&scoped=true&"
import script from "./setSignList.vue?vue&type=script&lang=js&"
export * from "./setSignList.vue?vue&type=script&lang=js&"
import style0 from "./setSignList.vue?vue&type=style&index=0&id=5cc4c63c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4c63c",
  null
  
)

export default component.exports